import { useState } from 'react';

import Button from '@ingka/button';
import TextArea from '@ingka/text-area';

import styles from './styles.module.scss';

interface Props {
    onAdd: (message: string) => Promise<boolean>;
    translate: (key: string) => string;
    onMessageChange?: (message: string) => void;
    onCancel?: () => void;
    isLoading?: boolean;
}

export const AddMessage = ({ onAdd, translate, onMessageChange, onCancel, isLoading }: Props) => {
    const [message, setMessage] = useState<string>('');

    const handleAddMessage = async () => {
        const payload = message;
        setMessage('');

        const success = await onAdd(payload);
        if (!success) {
            setMessage(message);
        }
    };

    const handleChange = (value: string) => {
        setMessage(value);
        onMessageChange?.(value);
    };

    const handleCancel = () => {
        setMessage('');
        onCancel?.();
    };

    return (
        <div>
            <TextArea
                id="add-message-textarea"
                data-testid="add-message-textarea"
                label={translate('messages_modal_add_message_label')}
                value={message}
                onChange={(e) => {
                    handleChange(e.target.value);
                }}
            />
            <div className={styles.addMessageActions}>
                <Button
                    text={translate('messages_modal_cancel_button')}
                    type="secondary"
                    size="small"
                    onClick={handleCancel}
                />
                <Button
                    text={translate('messages_modal_add_message_button')}
                    type="primary"
                    size="small"
                    onClick={() => void handleAddMessage()}
                    disabled={!message.trim()}
                    data-testid="add-message-button"
                    loading={isLoading ?? false}
                />
            </div>
        </div>
    );
};
